const langs = {
    language: {
        name: '简体中文',
    },
    common:{
        more:"更多>>",
        company:"丁丁健康官方网站"
    },
    header:{
        home:'首页',
        service:'产品服务',
        about:'关于我们',
        contact:'联系我们',
        others:'企业门户',
        other_option1:'医生门户',
        other_option2:'运营门户'
    },
    footer:{
        tel_label:"联系电话",
        tel_val:"400-668-1008",
        email_label:"企业邮箱",
        company_address_label:"公司地址",
        company_address:"广东省广州市黄浦区至泰广场A4栋606室",
        copyright:"版本所有@2022 广州丁丁云康科技有限公司",
        case_number:"备案号:粤ICP备2022046615号-1"
    },
    home:{
        company_profile:"丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析......",
        health_intervention:"健康干预",
        health_intervention_desc:"通过无缝、高效的健康干预服务，丁丁云康可以帮助客户随时随地掌握自己的健康状况、促进目标。了解健康促进计划与效果，从而有计划、有步骤地以多种形式改善个人的生活方式和习惯，实现个人健康管理计划的目标。",
        partner_organization:"合作机构",
    },
    service:{
        tab1:'产品服务',
        tab2:'体检中心',
        tab3:'健康服务',
        tab4:'社区服务',
        tab1_1:"丁丁健康智能体检系统V3.0",
        tab1_2:"丁丁健康智能排队系统V3.0",
        tab1_3:"丁丁健康智能LIS系统V3.0",
        tab1_4:"丁丁健康智能PACS系统V3.0",
        tab1_5:"丁丁健康智能OA系统V3.0",
        tab1_6:"丁丁健康智能健康管理系统V3.0",
        tab1_7:"丁丁健康智能回访系统V3.0",
        tab1_8:"丁丁健康中医体质辨识软件V3.0",
        tab1_9:"丁丁健康妇幼保健系统V5.0",
        tab1_10:"丁丁健康职业病体检系统V5.0",
        tab1_11:"丁丁健康APP",
        tab2_text:"强大的体检中心管理系统，全数字化管理软件，实现完备的体检业务流程，为体检中心的业务扩展提供有力的技术支撑。",
        tab3_text:"面向用户的健康管理服务，通过逐步改善个人的生活方式和习惯，提升个人健康水平、远离疾病。",
        tab4_text:"完善的产品体系，助力社区开展基层健康管理与用户跟踪服务。",
    },
    contact:{
        tab1:'加盟合作',
        tab2:'招聘精英',
        tab1_address_label_1:'广州公司地址:',
        tab1_address_1:'广东省广州市黄浦区至泰广场A4栋606',
        tab1_address_label_2:'联系电话:',
        tab1_address_2:'',
        tab1_address_label_3:'北京公司地址:',
        tab1_address_3:'北京市密云区康馨雅苑38号楼3单元101',
        tab1_address_label_4:'联系电话:',
        tab1_address_4:'',
        tab1_address_label_5:'佛山公司地址:',
        tab1_address_5:'佛山顺德南德医科大学医疗大数据产业园首层110室',
        tab1_address_label_6:'联系电话:',
        tab1_address_6:'',
        tab1_address_label_7:'重庆公司地址:',
        tab1_address_7:'重庆市九龙坡区奥体运动街150号21-4房',
        tab1_address_label_8:'联系电话:',
        tab1_address_8:'',
        tab2_address_label_1:'联系电话:',
        tab2_address_1:'',
        tab2_address_label_2:'企业邮箱:',
        tab2_address_2:'',
        tab2_address_label_3:'公司地址:',
        tab2_address_3:'广东省广州市黄浦区至泰广场A4栋606',

    },
    about: {
        tab1:'公司概况',
        tab2:'公司资质',
        company_intro_1:"丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析。“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。",
        company_intro_2:"公司团队由资深信息技术专家和经验丰富的健康顾问组成，丁丁云康健康管理平台成功地为医疗机构、体检机构、社康中心、健管中心等单位提供健康管理的信息技术服务与支持。丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。",
        company_intro_3:"丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。",
        company_qualification_1:"广东省健康医疗大数据产业园入驻企业",
        company_qualification_2:"广东省医学大数据融合应用工程中心合作伙伴",
    },
};
export default langs



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js